const l = {
  "sans-serif": "Inter",
  serif: "PP Editorial New"
}, h = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18,
  "2xl": 20,
  "3xl": 24,
  "4xl": 28,
  "5xl": 32,
  "6xl": 36,
  h6: 40,
  h5: 48,
  h4: 56,
  h3: 64,
  h2: 72,
  h1: 80,
  hero2: 96,
  hero1: 128
}, e = {
  medium: "Medium",
  light: "Light",
  regular: "Regular",
  semibold: "Semi Bold"
}, i = {
  link: {
    textDecoration: "UNDERLINE"
  },
  text: {
    textDecoration: "NONE"
  },
  title: {
    textDecoration: "NONE"
  },
  hero: {
    textDecoration: "NONE"
  }
}, x = {
  sansSerif: {
    family: "Inter",
    size: {
      xs: 10,
      sm: 12,
      md: 14,
      lg: 16,
      xl: 18,
      "2xl": 20,
      "3xl": 24,
      "4xl": 28,
      "5xl": 32,
      "6xl": 36,
      h6: 40,
      h5: 48,
      h4: 56,
      h3: 64,
      h2: 72,
      h1: 80,
      hero2: 96,
      hero1: 128
    },
    weight: {
      light: "300",
      regular: "400",
      medium: "500",
      semiBold: "600",
      bold: "700"
    },
    lineHeight: {
      xs: 12,
      sm: 16,
      md: 20,
      lg: 24,
      xl: 26,
      "2xl": 28,
      "3xl": 32,
      "4xl": 36,
      "5xl": 40,
      "6xl": 44,
      h6: 50,
      h5: 58,
      h4: 66,
      h3: 74,
      h2: 82,
      h1: 92,
      hero2: 104,
      hero1: 136
    },
    letterSpacing: {
      xs: -0.4,
      sm: -0.6,
      md: -0.8,
      lg: -1,
      xl: -1,
      "2xl": -1.2,
      "3xl": -1.5,
      "4xl": -1.8,
      "5xl": -2,
      "6xl": -2,
      h6: -2,
      h5: -3,
      h4: -3,
      h3: -4,
      h2: -4,
      h1: -4,
      hero2: -5,
      hero1: -6
    }
  },
  serif: {
    family: "PP Editorial New",
    size: {
      xl: 18,
      "2xl": 20,
      "3xl": 24,
      "4xl": 28,
      "5xl": 32,
      "6xl": 36,
      h6: 40,
      h5: 48,
      h4: 56,
      h3: 64,
      h2: 72,
      h1: 80,
      hero2: 96,
      hero1: 128
    },
    weight: {
      light: "300",
      regular: "400",
      medium: "500",
      semiBold: "600",
      bold: "700"
    },
    lineHeight: {
      xl: 26,
      "2xl": 28,
      "3xl": 32,
      "4xl": 36,
      "5xl": 40,
      "6xl": 44,
      h6: 50,
      h5: 58,
      h4: 66,
      h3: 74,
      h2: 82,
      h1: 92,
      hero2: 104,
      hero1: 136
    },
    letterSpacing: {
      xl: 0,
      "2xl": 0,
      "3xl": 0,
      "4xl": 0,
      "5xl": 0,
      "6xl": 0,
      h6: 0,
      h5: 0,
      h4: 0,
      h3: 0,
      h2: 0,
      h1: 0,
      hero2: 0,
      hero1: 0
    }
  }
};
export {
  h as fontSizePrimitives,
  e as fontWeightPrimitives,
  x as fontsConfig,
  l as typeFacePrimitives,
  i as typographyPrimitives
};
